import axios from '../axios/axios';
import handler from './handler';
import { authHeader } from '../helpers';

function get(url, params = {}) {
  const headers = authHeader();
  const config = {
    headers,
    params,
  };

  return axios.get(url, config)
    .then(handler.handleResponse)
    .catch(handler.handleError);
}
const dataTableService = { get };

export default dataTableService;
